export enum ActionTypes {
  ROUTE_UPDATE_REQUEST = 'ROUTE_UPDATE_REQUEST',
  ROUTE_UPDATE_FAILED = 'ROUTE_UPDATE_FAILED',
  ROUTE_UPDATE_SUCCESS = 'ROUTE_UPDATE_V2_SUCCESS',

  ROUTE_EXECUTION_INFO_REQUEST = 'ROUTES_EXECUTION_INFO_REQUEST',
  ROUTE_EXECUTION_INFO_FAILED = 'ROUTES_EXECUTION_INFO_FAILED',
  ROUTE_EXECUTION_INFO_SUCCEEDED = 'ROUTES_EXECUTION_INFO_SUCCEEDED',

  ROUTES_DELETE_REQUEST = 'ROUTES_DELETE_REQUEST',
  ROUTES_DELETE_FAILED = 'ROUTES_DELETE_FAILED',
  ROUTES_DELETE_SUCCESS = 'ROUTES_DELETE_SUCCESS',

  EXPORT_ROUTES_REQUEST = 'EXPORT_ROUTES_REQUEST',
  EXPORT_ROUTES_FAILED = 'EXPORT_ROUTES_FAILED',
  EXPORT_ROUTES_SUCCESS = 'EXPORT_ROUTES_SUCCESS',

  EXPORT_NEW_ROUTING_REPORT_REQUEST = 'EXPORT_NEW_ROUTING_REPORT_REQUEST',
  EXPORT_NEW_ROUTING_REPORT_FAILED = 'EXPORT_NEW_ROUTING_REPORT_FAILED',
  EXPORT_NEW_ROUTING_REPORT_SUCCESS = 'EXPORT_NEW_ROUTING_REPORT_SUCCESS',
}
